<mat-selection-list (selectionChange)="onAssetSelect($event)"
  [multiple]="false">
  @for (asset of assets; track asset) {
    <mat-list-option
      [value]="asset">
      {{ asset }}
    </mat-list-option>
  }
  <mat-divider></mat-divider>
  <mat-list-option>
    {{ 'CANCEL' | translate }}
  </mat-list-option>
</mat-selection-list>
